import { List } from 'immutable'
import React from 'react'
import { Updater, fromJSX, Widget } from 'widgets-for-react'
import { ActionProps, InviewProps, SVGIconProps } from '../blocksState'
import { ExpandBlockLayout } from './expandBlockLayout'
import { ExpandBlockState, expandBlockStateUpdaters } from './expandBlockState'
import { LinkBlockNested } from './nestedBlocks/linkBlockNestedLayout'
import { MediaBlockNested } from './nestedBlocks/mediaBlockNestedLayout'
import { QuoteBlockNested } from './nestedBlocks/quoteBlockNestedLayout'
import { TextBlockNested } from './nestedBlocks/textBlockNestedLayout'

export type ExpandBlock = {
  index: number
  title?: React.ReactNode
  intro?: string
  items: ExpandItem[]
  primaryAction?: ActionProps
  inview?: InviewProps
  expandBlockState: ExpandBlockState
}

export type ExpandItem = {
  title: string
  intro?: string
  subtitle?: string
  text?: string
  SVGIcon?: SVGIconProps
  nestedBlocks: List<NestedBlock>
}

export type NestedBlock =
  | ({
      kind: 'textBlockNested'
    } & TextBlockNested)
  | ({
      kind: 'quoteBlockNested'
    } & QuoteBlockNested)
  | ({
      kind: 'mediaBlockNested'
    } & MediaBlockNested)
  | ({
      kind: 'linkBlockNested'
    } & LinkBlockNested)

export type ExpandBlockStyle = Partial<{
  blockClassName: string
  inviewClassName: string
  innerClassName: string
  headerClassName: string
  titleClassName: string
  introClassName: string
  contentClassName: string
  listClassName: string
  footerClassName: string
  clickableClassName: string
  clickableWrapperClassName: string
  clickableLabelClassName: string
  clickableIconClassName: string
  expandItemClassName: string
  expandButtonClassName: string
  expandTitleClassName: string
  expandSubtitleClassName: string
  expandIconClassName: string
  expandContentClassName: string
  expandTextClassName: string
  iconId: string
  iconOpenId: string
  iconClosedId: string
}>

export const expandBlockWidget = (
  block: ExpandBlock & {
    videoCookieAccepted: boolean
    acceptVideoCookie: () => void
  }
): Widget<Updater<ExpandBlockState>> =>
  fromJSX((setState) => (
    <ExpandBlockLayout
      {...block}
      expand={(item: number) => setState(expandBlockStateUpdaters.expandBlockItemUpdater(item))}
    />
  ))
